enum LookupEnum {
  Vin = "Vin",
  VehicleName = "VehicleName",
}

export default LookupEnum;
